import PaymentMethod from '../../Components/PaymentMethod/PaymentMethod';
import css from './PaymentMethods.module.css';

const PaymentMethods = ({colors, handle}) => {
	const opts = [
		'One Time',
		'Recurring',
	];

	return (
		<div className={css.container}>
			{
				opts.map((text, idx) => <PaymentMethod onClick={() => {
					handle(idx);
				}} style={colors[idx]} text={text} key={idx}/>)
			}
		</div>
	);
};

export default PaymentMethods;